import { useSelector } from "react-redux";
import { useRestAPI } from "./axiosAPI";
import { RootState } from "src/redux/store";
import { useCentralAPI } from "./centralAPI";
import { useQuery } from "@tanstack/react-query";
import { Iteration, Team } from "src/types";
import { useActiveProjectTeamsAPI } from "./centralAPIActiveProjectTeams";

export function useActiveProjectTeamsIterationsAPI({
    retryCount,
    trigger = true,
}: {
    retryCount?: number,
    trigger?: boolean,
    
}) {
    const api = useRestAPI()
    const userData = useSelector((state: RootState) => state.user.adminDetails)
    const {
        ActiveProjectTeams,
        error: errorActiveProjectTeams,
        isError: isErrorActiveProjectTeams,
        isFetched: isFetchedActiveProjectTeams,
        isFetching: isFetchingActiveProjectTeams,
        isLoading: isLoadingActiveProjectTeams,
        refetch: refetchActiveProjectTeams
    } = useActiveProjectTeamsAPI({ trigger: true })

    const {
        centralData,
        isFetching: isFetchingCentralData,
        isFetched: isFetchedCentralData,
        isError: isErrorCentralData,
        error: errorCentralData
    } = useCentralAPI({
        trigger: false
    });

    async function loadIterationsUnderTeam({ organizationName, projectId, teamId }: { organizationName: string, projectId: string, teamId: string }) {

        type IterationResponse = {
            count: number,
            value: {
                id: string,
                name: string,
                path: string,
                attributes: {
                    startDate: string,
                    finishDate: string,
                    timeFrame: string
                },
                url: string,
            }[]
        }

        const response = await api.get<IterationResponse>({
            url: `https://dev.azure.com/${organizationName}/${projectId}/${teamId}/_apis/work/teamsettings/iterations`,
            mode: 'protected',
            params: {
                'api-version': '7.1',
                // '$timeframe': 'current'
            },
        })
        if (response.success === false) {
            throw response.msg
        }
        return response.value
    }

    async function loadCapacityUnderIteration({ organizationName, projectId, teamId, iterationId }: { organizationName: string, projectId: string, teamId: string, iterationId: string }) {

        type Capacity = {
            teamMembers: {
                teamMember: {
                    displayName: string,
                    url: string,
                    _links: {
                        avatar: {
                            href: string
                        }
                    },
                    id: string,
                    uniqueName: string,
                    imageUrl: string,
                    descriptor: string
                },
                activities: {
                    capacityPerDay: number,
                    name: string
                }[],
                daysOff: [],
                url: string
            }[],
            totalCapacityPerDay: number,
            totalDaysOff: number
        }


        const response = await api.get<Capacity>({
            url: `https://dev.azure.com/${organizationName}/${projectId}/${teamId}/_apis/work/teamsettings/iterations/${iterationId}/capacities`,
            mode: 'protected',
            params: {
                'api-version': '7.1'
            },
        })
        // console.log((response as any).typeKey)
        if (response.success === false) {
            throw response.msg
        }
        return response
    }

    const {
        data: ActiveProjectTeamsIterations,
        isLoading,
        isError,
        refetch: refetchActiveProjectTeamsIterations,
        isFetching,
        isFetched,
        error
    } = useQuery({
        queryKey: ['active-project-teams-iterations'],
        queryFn: async (): Promise<Iteration[]> => {

            if (!ActiveProjectTeams || !ActiveProjectTeams.length || isFetchingActiveProjectTeams) return []
            let Iteration: Iteration[] = []

            //load all iterations under active projects teams
            await Promise.all(ActiveProjectTeams.map(async (team) => {

                const organization = centralData?.Organizations.find((organization) => organization.accountId === team.organization_accountId)

                try {

                    const iterations = await loadIterationsUnderTeam({ organizationName: organization?.accountName || '', projectId: team.projectId, teamId: team.id })

                    //load all capacity under iterations
    
                    await Promise.all(iterations.map(async (iteration) => {
    
                        try {
                            const capacity = await loadCapacityUnderIteration({ organizationName: organization?.accountName || '', projectId: team.projectId, teamId: team.id, iterationId: iteration.id })
                            Iteration.push({
                                ...iteration,
                                projectId: team.projectId,
                                organization_accountId: team.organization_accountId,
                                teamId: team.id,
                                capacity
                            })
                        } catch (error) {
    
                        }
    
                    }))
                    
                } catch (error) {
                    
                }

               



            }))




            return Iteration



        },
        refetchOnWindowFocus: false,
        retry: retryCount,
        enabled: !isFetchingActiveProjectTeams && isFetchedActiveProjectTeams,


    })

    return {
        ActiveProjectTeamsIterations,
        isLoading,
        isError,
        refetchActiveProjectTeamsIterations,
        isFetching,
        isFetched,
        error
    }

}